import { useEffect, useRef, useState } from 'react';
import { getConversations } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
export const useChatHistory = _ref => {
  let {
    httpClient,
    enabled = true,
    origin = 'https://manage.wix.com'
  } = _ref;
  const [conversations, setConversations] = useState([]);
  const isConversationsRequested = useRef(false);
  useEffect(() => {
    (async () => {
      if (!enabled || isConversationsRequested.current) {
        return;
      }
      isConversationsRequested.current = true;
      const {
        data
      } = await httpClient.request(getConversations({
        origin
      }));
      const conversationList = (data.conversations ?? []).map(conv => ({
        id: conv.id || '',
        name: conv.name || '',
        createdDate: conv.createdDate || new Date(0)
      }));
      setConversations(conversationList);
    })();
  }, [httpClient, enabled, origin]);
  return {
    conversations
  };
};
//# sourceMappingURL=useChatHistory.js.map